import React, { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper as SwiperReact, SwiperSlide } from "swiper/react";
import chevronBackward from "../Assets/icons/chevron_backward.svg";

function Swiper({ children, ...props }) {
  const slides = React.Children.toArray(children);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  const updateNavState = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="acoris__swiper relative">
      <SwiperReact
        slidesPerView={"auto"}
        spaceBetween={12}
        centerInsufficientSlides={true}
        onSwiper={(swiper) => {
          setSwiperInstance(swiper);
          updateNavState(swiper);
        }}
        onSlideChange={updateNavState}
        onReachBeginning={updateNavState}
        onReachEnd={updateNavState}
        breakpoints={{
          100: { slidesPerView: 1, centeredSlides: true },
          320: { slidesPerView: 1, centeredSlides: true },
          520: { slidesPerView: 1, centeredSlides: true },
          640: { slidesPerView: 2, centeredSlides: false, spaceBetween: 12 },
          768: { slidesPerView: 2, centeredSlides: false, spaceBetween: 12 },
          // -2 overlaps adjacent 2px borders (Figma mr-[-2px] on 773:6214)
          840: { slidesPerView: 3, centeredSlides: false, spaceBetween: -2 },
          1024: { slidesPerView: 3, centeredSlides: false, spaceBetween: -2 },
          1099: { slidesPerView: 3, centeredSlides: false, spaceBetween: -2 },
          1199: { slidesPerView: 3, centeredSlides: false, spaceBetween: -2 },
        }}
        {...props}
      >
        {slides.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </SwiperReact>
      <button
        type="button"
        className={`swiper-button-prev acoris-swiper-prev ${
          isBeginning ? "swiper-button-disabled" : ""
        }`}
        onClick={handlePrev}
        disabled={isBeginning}
        aria-label="Previous"
      >
        <img
          src={chevronBackward}
          alt=""
          className="acoris-swiper-chevron"
          width={20}
          height={20}
        />
      </button>
      <button
        type="button"
        className={`swiper-button-next acoris-swiper-next ${
          isEnd ? "swiper-button-disabled" : ""
        }`}
        onClick={handleNext}
        disabled={isEnd}
        aria-label="Next"
      >
        <img
          src={chevronBackward}
          alt=""
          className="acoris-swiper-chevron acoris-swiper-chevron--next"
          width={20}
          height={20}
        />
      </button>
    </div>
  );
}

export default React.memo(Swiper);
